import * as React from "react"
import { batch } from "@preact/signals-react"
import { Grid } from "@mui/material"
import {string, number, object, array} from "yup";
import { DrawerSeeker, TextFieldSeeker, SelectSeeker, TagFieldSeeker } from "@ui-seeker/core"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import { isEmpty } from '@ui-seeker/utils'

import { priceChangesReportFormIsOpen } from "../@signals"
import { usePricingChangeForm } from "../@hooks"
import { OPTIONS_CONDITIONS, OPTIONS_FREQUENCY, PRICES_PERCENTAGES_UNDER_REFERENCE } from "./constants"


export default function PriceChangeReportFormDrawer() {
	const { showToast } = useAppToast()
	const {
		handleSendToBack, nameReport, frequency, emailsReport, conditions,
		priceUnderReference, percentagePriceUnder, resetFormData
	} = usePricingChangeForm()

	const validatorData = useValidatorSeeker({
        nameReport: nameReport.value,
		frequency: frequency.value,
        emailsReport: emailsReport.value,
        conditions: conditions.value
    }, object({
        nameReport: string().required('Report name must be provided'),
		frequency: string().required('Frequency must be provided'),
        emailsReport: array().min(1, 'At least 1 email is required'),
		conditions: number().required('Condition must be provided')
    }))

	if (!priceChangesReportFormIsOpen.value) return <></>

    return <DrawerSeeker
		isOpen={priceChangesReportFormIsOpen.value}
		controller={() => {
			priceChangesReportFormIsOpen.value = false
			resetFormData()
		}}
		title={`Create New Price Changes Report`}
		width="40%"
		successProps={{ onClick: isEmpty(validatorData.errors)
			? handleSendToBack
			: () => showToast.warning('Please ensure all mandatory fields are completed ') 
		}}
	>
    	<Grid container spacing={3}>
			<Grid item xs={12}>
				<TextFieldSeeker
					error={validatorData.errors?.nameReport}
					label="Report Name"
					size="small"
					fullWidth
					value={nameReport.value}
					onChange={e => nameReport.value = e.target.value}
					icon="pen-to-square"
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.frequency}
					label="Frequency"
					fullWidth
					options={OPTIONS_FREQUENCY}
					value={frequency.value}
					onChange={e => frequency.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<TagFieldSeeker
					error={validatorData.errors?.emailsReport}
					value={emailsReport.value}
					fullWidth
					onChange={e => emailsReport.value = e }
					label="Emails"
					placeholder="Enter to add emails"
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.conditions}
					label="Conditions"
					fullWidth
					options={OPTIONS_CONDITIONS}
					value={conditions.value}
					onChange={e => conditions.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					label="Only include prices under Reference"
					fullWidth
					options={[
						{label: 'Yes', value: 'true'},
						{label: 'No', value: 'false'},
					]}
					value={priceUnderReference.value}
					onChange={e => priceUnderReference.value = e.target.value}
				/>
			</Grid>

			{!!JSON.parse(priceUnderReference.value) && <Grid item xs={12}>
				<SelectSeeker
					label="Filter by % Below Reference?"
					fullWidth
					options={PRICES_PERCENTAGES_UNDER_REFERENCE}
					value={percentagePriceUnder.value}
					onChange={e => percentagePriceUnder.value = e.target.value}
				/>
			</Grid>}

		</Grid>
    </DrawerSeeker>
}